import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin, ShieldCheck, Truck } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_hire-showcase/artifacts/tllvl69e_IMG_0034.PNG";

export default function Hero({ onBookClick }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-secondary text-white border-b border-white/10 overflow-hidden"
    >
      {/* Logo backdrop */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none flex items-center justify-center"
      >
        <img
          src={LOGO}
          alt=""
          className="w-[110%] max-w-[1100px] object-contain opacity-[0.18] mix-blend-screen select-none"
        />
      </div>

      {/* Subtle grid + vignette */}
      <div className="absolute inset-0 bg-grid opacity-[0.05] pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-r from-secondary via-secondary/60 to-transparent pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-6 min-h-[calc(100vh-4rem)] py-12 md:py-16 flex flex-col justify-center">
        <div className="relative z-10 max-w-3xl">
          <div
            className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-orange-500/15 border border-orange-500/40 text-orange-300 font-heading uppercase tracking-[0.2em] text-[11px]"
            data-testid="hero-chip"
          >
            <MapPin className="w-3 h-3" />
            <span>Warragamba · Wallacia · Penrith</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading uppercase text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[0.95]"
          >
            Compact equipment.
            <br />
            <span className="text-orange-500">Professional results.</span>
          </h1>

          <p className="mt-6 text-lg text-white/70 max-w-xl leading-relaxed">
            High-quality mini excavator hire.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              data-testid="hero-quote-btn"
              onClick={onBookClick}
              size="lg"
              className="btn-sharp bg-orange-500 hover:bg-orange-600 text-white font-heading uppercase tracking-wider h-12 px-6"
            >
              Get a Quote <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <a href="#equipment" data-testid="hero-browse-link">
              <Button
                size="lg"
                variant="outline"
                className="btn-sharp h-12 px-6 border-white/40 bg-transparent text-white hover:bg-white hover:text-secondary font-heading uppercase tracking-wider"
              >
                Browse Equipment
              </Button>
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { icon: Truck, label: "Free Delivery*", sub: "Local jobs" },
              { icon: ShieldCheck, label: "Fully Insured", sub: "Public liability" },
              { icon: MapPin, label: "Local Operator", sub: "Warragamba based" },
            ].map((s, i) => (
              <div key={i} className="border-l-2 border-orange-500 pl-3">
                <s.icon className="w-5 h-5 text-orange-400 mb-1" />
                <div className="font-heading uppercase text-sm tracking-wider text-white">
                  {s.label}
                </div>
                <div className="text-xs text-white/60">{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
